<template>
  <div class="container footer">
    <span>
      <i class="fa fa-copyright"></i>
      {{ $t('footer.copyright') }}{{ year }}
    </span>
    <i18n path="footer.consent" tag="span" class="consent">
      <router-link to="/privacy" target="_blank">{{
        $t('footer.terms')
      }}</router-link>
      <router-link to="/terms" target="_blank">{{
        $t('footer.privacy')
      }}</router-link>
    </i18n>
    |
    <a href="https://forms.gle/dEBSiNrG2pn66ZfGA" target="_blank">{{
      $t('footer.feedback')
    }}</a>
    <br />
    {{ version }}
  </div>
</template>

<script>
export default {
  computed: {
    year() {
      return new Date().getFullYear()
    },
    version() {
      return `${
        process.env.VUE_APP_VERSION
      }-${process.env.VUE_APP_GIT_HASH.slice(0, 6)}`
    },
  },
}
</script>

<style lang="scss">
.footer {
  margin-bottom: 20px;
  font-size: 1rem;
  padding: 0 10px 30px;

  @media (min-width: 576px) {
    padding: 20px 0 30px;
  }
}
</style>
